import { formatISO } from 'date-fns';
import { useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { ApplicationContext } from '~/shared/context/context';

import { VIEW_SEARCH_PARAM } from '../../url-navigation/view-search-param';

type ViewMode = 'board' | 'table';

type JsaTrackingContext = {
    readonly editorRoles: readonly string[];
    readonly tenantId: string;
    readonly timestamp: string;
    readonly userId: string;
    readonly viewMode: ViewMode;
};

export const useJsaTrackingContext = (): JsaTrackingContext => {
    const { applicationState } = useContext(ApplicationContext);
    const { clock, customization, myUserProfile } = applicationState;

    const [searchParams] = useSearchParams();

    const tenantId = customization.get('tenantId').unwrapOr('');
    const userId = myUserProfile.map((profile) => profile.id).unwrapOr('');
    const editorRoles = myUserProfile.map((profile) => profile.roles ?? []).unwrapOr([]);
    const viewMode: ViewMode = searchParams.get(VIEW_SEARCH_PARAM) === 'table' ? 'table' : 'board';

    return useMemo(
        () => ({
            editorRoles,
            tenantId,
            timestamp: formatISO(clock.getCurrentTimestamp()),
            userId,
            viewMode,
        }),
        [tenantId, userId, editorRoles, viewMode, clock],
    );
};
